import { IEventGuestStatus } from "Bands/types";
import { copy } from "shared/assets";
import { IFieldType, IFormFields, IFormOption } from "shared/types";

const properties = copy.guestlistBlock.guests.create.properties;

export const getFields = ({
  hideStatus,
  maxTicketsPerEntry,
  ticketAndPasses,
}: {
  hideStatus?: boolean;
  maxTicketsPerEntry: number;
  ticketAndPasses: IFormOption[];
}): IFormFields => [
  {
    name: "firstname",
    label: properties.firstname,
    type: IFieldType.text,
    validation: {
      required: copy.errors.required,
    },
    style: {
      gridColumn: "span 2",
    },
  },
  {
    name: "lastname",
    label: properties.lastname,
    type: IFieldType.text,
    validation: {
      required: copy.errors.required,
    },
    style: {
      gridColumn: "span 2",
    },
  },
  {
    name: "nbGuests",
    label: properties.nbGuests,
    type: IFieldType.number,
    validation: {
      required: copy.errors.required,
      min: 1,
      max: maxTicketsPerEntry,
    },
    style: {
      mobile: {
        gridColumn: "span 2",
      },
    },
  },
  {
    name: "source",
    label: properties.source,
    type: IFieldType.text,
    style: {
      gridColumn: "span 3",
      mobile: {
        gridColumn: "span 2",
      },
    },
  },
  {
    name: "ticketAndPassTypes",
    label: properties.ticketAndPassTypes,
    type: IFieldType.checkboxGroup,
    options: ticketAndPasses,
    validation: {
      required: copy.errors.required,
    },
    style: {
      gridColumn: "span 4",
    },
  },
  {
    name: "status",
    label: properties.status.title,
    type: IFieldType.radioGroup,
    isInline: false,
    isHidden: hideStatus,
    options: [
      {
        label: properties.status.options.approved,
        value: IEventGuestStatus.approved,
      },
      {
        label: properties.status.options.pending,
        value: IEventGuestStatus.pending,
      },
      {
        label: properties.status.options.denied,
        value: IEventGuestStatus.denied,
      },
    ],
    validation: {
      required: copy.errors.required,
    },
    style: {
      gridColumn: "span 4",
    },
  },
];
